"use client";
import React from "react";
import { VideoItem } from "./MediaItem";
import { PhotoProvider, PhotoView } from 'react-photo-view';

export const ImageGallery = ({ images }) => {
    if (!images || images.length === 0) return null;

    return (
        <>
            <div className="flex flex-wrap items-center my-6">
                <PhotoProvider>
                    <div className="flex flex-row">
                        {images.map((item, index) => (
                            <PhotoView key={index + item.url} src={item.url}>
                                <img src={item.url} alt="" className="m-2 h-36" />
                            </PhotoView>
                        ))}
                    </div>
                </PhotoProvider>
            </div>
        </>

    );
};

export const VideoGallery = ({ videos }) => {
    if (!videos || videos.length === 0) return null;


    return (
        <div className="flex flex-wrap items-center my-6">
            <div className="flex flex-row">
                {videos.map((item, index) => (
                    <VideoItem key={index} {...item} />
                ))}
            </div>
        </div>

    );
};
